import React from 'react';
import styles from './InfoModal.module.scss';
import Modal from 'react-bootstrap/Modal';

export type infoModalProps = {
  /**
   * if the modal shows or not
   */
  visibility: boolean;
  /**
   * onChange function to control visibility of the modal
   */
  setShow: any;
  /**
   * object with the text contents of the modal
   */
  modalData: any;
};

const InfoModal = ({ visibility, setShow, modalData }: infoModalProps) => {
  const handleClose = () => setShow(false);
  return (
    <div className={styles.InfoModal} data-testid="InfoModal">
      <Modal show={visibility}>
        <Modal.Header closeButton onClick={handleClose}>
          <Modal.Title>
            {modalData.type}: {modalData.code}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{modalData.message}</p>
          <p>
            If you are experiencing timesheet issues, please{' '}
            <a href="https://crosscountryhealthcare.com/docs/no-ca-timesheet-sun-sat.pdf">
              download a timesheet
            </a>{' '}
            (California employees please{' '}
            <a href="https://crosscountryhealthcare.com/docs/cross-country-timesheet-sun-sat.pdf">
              download this version
            </a>
            ) and submit to{' '}
            <a href="mailto:time@crosscountry.com">time@crosscountry.com</a> as
            soon as possible to ensure you are paid on time.
          </p>
          <p>
            Questions? Please call our hotline at{' '}
            <a href="tel:800-530-6125">800-530-6125</a>.
          </p>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </div>
  );
};

export default InfoModal;
